import { IModalOpenerProps } from '@cian/frontend-newbuilding-broker-component';
import { Button } from '@cian/ui-kit';
import * as React from 'react';

export const NewbuildingBrokerButton: React.VFC = ({ onClick }: IModalOpenerProps) => (
  <Button onClick={onClick} theme="fill_success_primary" fullWidth size="XS">
    Продать квартиру
  </Button>
);
